import React, { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "../lib/api";

export const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | pending | error
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let attempts = 0;
    let timer;
    const poll = async () => {
      if (!sessionId) { setState("error"); return; }
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        setInfo(r.data);
        if (r.data.payment_status === "paid") { setState("paid"); return; }
        if (attempts >= 6) { setState("pending"); return; }
        attempts += 1;
        timer = setTimeout(poll, 2000);
      } catch (e) {
        setState("error");
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="pay-result">
      <div className="pay-card">
        {state === "checking" && (<><Loader2 size={44} className="spin" /><h1>Confirming your payment...</h1><p>Please wait a moment.</p></>)}
        {state === "paid" && (<><CheckCircle2 size={54} color="#3fae4a" /><h1>Payment successful!</h1><p>Thank you — your ${info?.amount} {info?.label} payment is confirmed.</p><div className="pay-actions"><Link to="/training" className="btn btn-primary">Go to my course</Link><Link to="/" className="btn btn-pay">Back to home</Link></div></>)}
        {state === "pending" && (<><Loader2 size={44} /><h1>Payment processing</h1><p>Your payment is still processing. You'll receive confirmation soon.</p><Link to="/" className="btn btn-primary">Back to home</Link></>)}
        {state === "error" && (<><XCircle size={54} color="#d9534f" /><h1>Couldn't confirm payment</h1><p>Please contact dispatch at 815-406-9774 if you were charged.</p><Link to="/" className="btn btn-primary">Back to home</Link></>)}
      </div>
    </div>
  );
};

export const PaymentCancel = () => (
  <div className="pay-result">
    <div className="pay-card">
      <XCircle size={54} color="#d9534f" />
      <h1>Payment canceled</h1>
      <p>No charge was made. You can try again anytime.</p>
      <Link to="/" className="btn btn-primary">Back to home</Link>
    </div>
  </div>
);
